import { getExtension } from '@piccolohealth/util';
import React from 'react';
import {
  FaFile,
  FaFileCsv,
  FaFileExcel,
  FaFileImage,
  FaFilePdf,
  FaFileVideo,
  FaFileWord,
} from 'react-icons/fa';
import { ChakraV3 } from '..';

export const getIcon = (name: string) => {
  const extension = getExtension(name);

  switch (extension) {
    case 'pdf':
      return { icon: <FaFilePdf size='100%' />, color: 'red.500', bg: 'red.50' };
    case 'csv':
      return { icon: <FaFileCsv size='100%' />, color: 'green.500', bg: 'green.50' };
    case 'xls':
    case 'xlsx':
      return { icon: <FaFileExcel size='100%' />, color: 'green.500', bg: 'green.50' };
    case 'doc':
    case 'docx':
      return { icon: <FaFileWord size='100%' />, color: 'blue.500', bg: 'blue.50' };
    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'gif':
      return { icon: <FaFileImage size='100%' />, color: 'orange.500', bg: 'orange.50' };
    case 'mp4':
    case 'avi':
    case 'wmv':
    case 'mov':
    case 'mkv':
      return { icon: <FaFileVideo size='100%' />, color: 'purple.500', bg: 'purple.50' };
    default:
      return { icon: <FaFile size='100%' />, color: 'gray.500', bg: 'gray.50' };
  }
};

interface Props extends ChakraV3.BoxProps {
  name: string;
}

export const FileIcon = (props: Props) => {
  const { name, ...rest } = props;
  const { icon, color, bg } = getIcon(name);

  return (
    <ChakraV3.Center w={16} h={16} p={1} rounded='xl' bg={bg} {...rest}>
      <ChakraV3.Box color={color} boxSize='70%'>
        {icon}
      </ChakraV3.Box>
    </ChakraV3.Center>
  );
};
